<template>
  <Sidebar>
    <SidebarHeader>
      <Header />
    </SidebarHeader>
    <SidebarContent>
      <MenuGroups :groups="menuGroups" />
    </SidebarContent>
    <SidebarFooter>
      <SignOutButton />
    </SidebarFooter>
  </Sidebar>
</template>

<script setup lang="ts">
import SignOutButton from '@/components/shared/SignOutButton.vue';
import Header from '@/components/shared/sidebar/Header.vue';
import { useAdminSidebar } from './useAdminSidebar.ts';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from '@/components/ui/sidebar';
import MenuGroups from '@/components/shared/sidebar/MenuGroups.vue';

const { menuGroups } = useAdminSidebar();
</script>
